import { Injectable } from '@angular/core';
import { PreferenceConverterHelper } from '@app/shared/helper/preference-converter-helper';
import { BehaviorSubject } from 'rxjs';
import { UserProfileModel } from '../models/users/user-profile.model';
import { UserService } from '../services/user.service';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationInfoService {

  public authentificatedUser: UserProfileModel;
  private userProfileLoadedSubject$ = new BehaviorSubject<UserProfileModel>(null);
  public userProfileLoaded$ = this.userProfileLoadedSubject$.asObservable();
  private userLoggedInSubject$ = new BehaviorSubject<boolean>(false);
  public userLoggedIn$ = this.userLoggedInSubject$.asObservable();

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private converterHelper: PreferenceConverterHelper,
  ) {

    this.authService.canActivateProtectedRoutes$.subscribe((hasIdentityClaims) => {
      this.userLoggedInSubject$.next(hasIdentityClaims);
      if (hasIdentityClaims) {
        this.refresh();
      }
    });
  }

  public refresh(): void {
    this.userService.getUserProfile().subscribe((userProfile: UserProfileModel) => {
      this.authentificatedUser = Object.assign(new UserProfileModel(), userProfile);

      userProfile.TablesPreferences?.forEach(tablePreference => {
        localStorage.setItem(`table_config_${tablePreference.TableId}`, this.converterHelper.convertTocolumnsDefString(tablePreference.Configuration));
      });

      this.userProfileLoadedSubject$.next(this.authentificatedUser);
    });
  }

  public get name() { return `${this.authentificatedUser.LastName} ${this.authentificatedUser.FirstName}`; }

  public get name_simple() { return `${this.authentificatedUser?.FirstName} ${this.authentificatedUser?.LastName[0].toUpperCase()}.`; }

  public get name_initial() { return `${this.authentificatedUser.FirstName[0].toUpperCase()}${this.authentificatedUser.LastName[0].toUpperCase()}`; }

}
